import React from 'react'

const SearchIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="searchGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(150, 150, 255, 1)" />
          <stop offset="100%" stopColor="rgba(100, 100, 220, 1)" />
        </linearGradient>
        <filter id="searchGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Magnifying glass circle */}
      <circle 
        cx="11" 
        cy="11" 
        r="7" 
        stroke="url(#searchGradient)"
        strokeWidth="2.5"
        fill="none"
        filter="url(#searchGlow)"
      />
      
      {/* Handle */}
      <line 
        x1="16" 
        y1="16" 
        x2="21" 
        y2="21" 
        stroke="url(#searchGradient)"
        strokeWidth="2.5"
        strokeLinecap="round"
        filter="url(#searchGlow)"
      />
      
      {/* Inner highlight */}
      <circle 
        cx="9" 
        cy="9" 
        r="2" 
        fill="rgba(255, 255, 255, 0.3)"
      />
    </svg>
  )
}

export default SearchIcon
